<div class="unauthorized">
  <h1>Unauthorized</h1>
  <p>You don’t have permission to access this dashboard.</p>
  <button matTooltip="Logout" matTooltipPosition="below" mat-icon-button class="nav-icon" (click)="logout()">
    <mat-icon>exit_to_app</mat-icon>
  </button>
</div>